import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from 'react';
import { isNumber } from 'lodash-es';
import { makeStyles, Slider } from 'seagull';
import colors from 'seagull/foundations/colors.module.scss';
const STEP = 0.1;
const START_VALUE = 7.8;
const END_VALUE = 92.2;
function getValueAndPercent(rawValue) {
    const value = rawValue <= START_VALUE ? START_VALUE : rawValue >= END_VALUE ? END_VALUE : rawValue;
    return [
        value,
        (value - START_VALUE) / (END_VALUE - START_VALUE)
    ];
}
const getThumbStyle = (disabled)=>({
        height: 46,
        width: 46,
        marginTop: 4,
        marginLeft: -23,
        backgroundColor: disabled ? colors.dark120 : colors.dark50,
        '&, &:focus, &:hover': {
            boxShadow: "0px 1px 1px var(--button-primary-dark, ".concat(colors.purple900, ")")
        }
    });
const useStyles = makeStyles({
    root: {
        height: 54,
        color: "var(--button-primary, ".concat(colors.purple800, ")")
    },
    thumb: _object_spread_props(_object_spread({}, getThumbStyle(false)), {
        '&.Mui-disabled': getThumbStyle(true)
    }),
    rail: {
        background: (param)=>{
            let { disabled } = param;
            return disabled ? "linear-gradient(90deg, ".concat(colors.dark700, " 0%, #B7B3C5 99.83%, #8873D4 100%)") : "linear-gradient(90deg, var(--button-primary-light, ".concat(colors.purple700, ") 0%, var(--button-primary, ").concat(colors.purple800, ") 100%)");
        },
        height: 54,
        borderRadius: 90,
        opacity: 1
    }
});
export function SignSlider(param) {
    let { onSign, onChange, disabled } = param;
    const styles = useStyles({
        disabled
    });
    const [value, setValue] = useState(START_VALUE);
    const [, setPercent] = useState(0);
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsx(Slider, {
            disabled: disabled,
            value: value,
            classes: styles,
            valueLabelDisplay: "off",
            track: false,
            step: STEP,
            onChange: (_, rawValue)=>{
                if (isNumber(rawValue)) {
                    const [value, percent] = getValueAndPercent(rawValue);
                    setValue(value);
                    setPercent(percent);
                    onChange(percent);
                }
            },
            onChangeCommitted: (_, rawValue)=>{
                if (isNumber(rawValue)) {
                    const [, percent] = getValueAndPercent(rawValue);
                    if (percent >= 1) {
                        onSign();
                    }
                }
            }
        })
    });
}
